import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import { useHistory } from "react-router-dom";
import Button from "components/CustomButton";

export default ({ teamId, content, deleteWaterCooler = false, status }) => {
  const [alertOpen, setOpen] = useState(true);
  const history = useHistory();

  const closeAlert = () => {
    setOpen(false);

    if (!deleteWaterCooler || status === "409") {
      history.push(`/teams/${teamId}/timeline`);
      return;
    }

    deleteWaterCooler();
  };

  return (
    <Modal
      open={alertOpen}
      onClose={() => setOpen(false)}
      showCloseIcon={false}
      classNames={{ modalContainer: "modalContainer", modal: "modalPadding" }}
    >
      <div className="modalHeader">Watercooler</div>
      <div className="modalContent">{content}</div>
      <div className="modalAction">
        <Button onClick={closeAlert} buttonClass={"btn small-btn"}>
          Okay
        </Button>
      </div>
    </Modal>
  );
};
